import { memo, useMemo } from 'react';

import { useExternalRequest } from './hooks/useExternalRequest';
import { usePlatformRequest } from './hooks/usePlatformRequest';
import { RequestsContextProps } from './types/RequestsContextProps';
import { RequestsContext } from './RequestsContext';

const RequestsProviderComponent = ({ children }: RequestsContextProps) => {
  const platformRequest = usePlatformRequest();
  const externalRequest = useExternalRequest();
  const value = useMemo(
    () => ({ platformRequest, externalRequest }),
    [platformRequest, externalRequest],
  );

  return (
    <RequestsContext.Provider value={value}>
      {children}
    </RequestsContext.Provider>
  );
};

export const RequestsProvider = memo(RequestsProviderComponent);
